import posthog from 'posthog-js'

export default function ({ app: { route, store } }, inject) {
    if (String(route?.query?.preview ?? '').toLowerCase() === 'true') {
        window['ga-disable-G-3Y0M46RF6Y'] = true
        return
    }

    // if (process.env.NODE_ENV !== 'production') return
    // Init PostHog
    // posthog.init('phc_TjS9iJFozKF9D7TxyG5F0A5PDxUGzJOXze5Xqv3Qacz', {
    posthog.init('phc_TjS9iJFozKF9D7TxyG5F0A5PDxUGzJOXze5Xqv3Qacz', {
        api_host: 'https://app.posthog.com',
        session_recording: {
            maskAllInputs: false,
            inlineStylesheet: false,
        },
        capture_pageview: true,
        autocapture: true,
        rageclick: true,
        loaded: function () {
            console.info(
                '%c 1. [PH][SCRIPT][INIT] ',
                'color: white; background-color: #3483fa; padding: 1px;'
            )
        },
    })
}
